import {Observable} from 'rxjs';

export function getHttpWithoutCors<T>(url: string): Observable<T> {
    return Observable.create((observer) => {
                const xhr = new XMLHttpRequest();
                xhr.onreadystatechange = () => {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            observer.next(JSON.parse(xhr.response) as T);
                        } else {
                            observer.error(xhr);
                        }
                    }
                };
                xhr.open('GET', url, true);
                xhr.send();
            });
}
